import { createFileRoute } from "@tanstack/react-router";
import { ReposicaoPesquisaPage } from "@/paginas/reposicao-pesquisa";

export const Route = createFileRoute("/_authenticated/reposicao-pesquisa")({
  head: () => ({
    meta: [
      { title: "Histórico de reposições — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Pesquise as reposições de estoque por período, texto, categoria e usuário, com impressão e exportação em PDF.",
      },
      { property: "og:title", content: "Histórico de reposições — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Pesquise as reposições de estoque e totalize as quantidades recebidas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ReposicaoPesquisaPage,
});
